<template>
    <div id="app">

        <v-card flat style="width: 100%; height: 100%">
            <div style="width: 100%; height: 90%">
                <div style="width: 50%; height: 100%; float: left">
                    <div style="height: 10%; width: 100%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 2vw; color: rgba(0,0,0,0.5)">
                        Options
                    </div>

                    <div style="height: 90%; width: 50%; float: left">
                        <div style="height: 100%; width: 100%;">
                            <div style="width: 100%; height: 25%">
                                <div style="height: 40%; width: 100%;  display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 1vw; color: rgba(0,0,0,0.5)">
                                    Icon
                                </div>
                                <div style="height: 60%; width: 100%; display: flex; justify-content: center; align-items: center;">
                                    <v-btn :color="selectedIcon1" @click="selectIcon(1)" icon small><v-icon>fas fa-exclamation-triangle</v-icon></v-btn>
                                    <v-btn :color="selectedIcon2" @click="selectIcon(2)" icon small><v-icon>fas fa-exclamation-circle</v-icon></v-btn>
                                    <v-btn :color="selectedIcon3" @click="selectIcon(3)" icon small><v-icon>fas fa-info-circle</v-icon></v-btn>
                                    <v-btn :color="selectedIcon4" @click="selectIcon(4)" icon small><v-icon>fas fa-question-circle</v-icon></v-btn>
                                    <v-btn :color="selectedIcon5" @click="selectIcon(5)" icon small><v-icon>fas fa-minus-circle</v-icon></v-btn>
                                    <v-btn :color="selectedIcon6" @click="selectIcon(6)" icon small><v-icon>fas fa-tools</v-icon></v-btn>
                                    <v-btn :color="selectedIcon7" @click="selectIcon(7)" icon small><v-icon>fas fa-times-circle</v-icon></v-btn>
                                    <v-btn :color="selectedIcon8" @click="selectIcon(8)" icon small><v-icon>fas fa-check-circle</v-icon></v-btn>
                                </div>
                            </div>
                            <div style="width: 100%; height: 25%">
                                <div style="height: 40%; width: 100%;  display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 1vw; color: rgba(0,0,0,0.5)">
                                    Color
                                </div>
                                <div style="height: 60%; width: 100%; display: flex; justify-content: center; align-items: center;">
                                    <v-radio-group v-model="alertColor" row>
                                        <v-radio
                                                v-for="(colorValue, i) in ['Red', 'Orange', 'Green', 'Blue']"
                                                :key="i"
                                                :color="colorValue"
                                                :label="colorValue"
                                                :value="colorValue"
                                        ></v-radio>

                                    </v-radio-group>
                                </div>
                            </div>
                            <div style="width: 100%; height: 25%">
                                <div style="height: 40%; width: 100%;  display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 1vw; color: rgba(0,0,0,0.5)">
                                    Text
                                </div>
                                <div style="height: 60%; width: 100%; display: flex; justify-content: center; align-items: center; padding-left: 10%; padding-right: 10%">
                                    <v-text-field v-model="alertText" color="#2e2e2e" outlined rounded clearable>

                                    </v-text-field>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div style="height: 90%; width: 50%; float: left">
                        <div style="height: 100%; width: 100%;">
                            <div style="width: 100%; height: 10%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 1vw; color: rgba(0,0,0,0.5)">
                                <!--<div style="height: 40%; width: 100%;  display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 1vw; color: rgba(0,0,0,0.5)">-->
                                    Time
                            </div>

                            <div style="width: 100%; height: 5%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 0.85vw; color: rgba(0,0,0,0.5)">
                               From:
                            </div>

                            <div style="height: 35%; width: 100%;">
                                <div style="width: 100%; float: left; height: 50%; display: flex; justify-content: center; align-items: center; padding-left: 5%; padding-right: 5%">
                                <v-menu
                                    ref="fromDateMenu"
                                    v-model="fromDateMenu"
                                    :close-on-content-click="false"
                                    :return-value.sync="pickedFromDate"

                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="pickedFromDate"
                                            label="Date From"
                                            outlined
                                            rounded
                                            prepend-icon="fas fa-calendar"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                <v-date-picker
                                        first-day-of-week="1"
                                        v-model="pickedFromDate" no-title scrollable>
                                    <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="fromDateMenu = false">Cancel</v-btn>
                                        <v-btn text color="primary" @click="$refs.fromDateMenu.save(pickedFromDate)">OK</v-btn>
                                </v-date-picker>
                                </v-menu>
                            </div>
                            <div style="width: 100%; float: left; height: 50%; display: flex; justify-content: center; align-items: center; padding-left: 5%; padding-right: 5%">
                                <v-text-field
                                        label="Time From"
                                        outlined
                                        rounded
                                        prepend-icon="fas fa-clock"
                                        type="time"
                                        v-model="pickedFromTime"
                                ></v-text-field>
                            </div>
                            </div>

                            <div style="width: 100%; height: 5%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 0.85vw; color: rgba(0,0,0,0.5)">
                                To:

                            </div>

                            <div style="height: 35%; width: 100%;">
                                <div style="width: 100%; float: left; height: 50%; display: flex; justify-content: center; align-items: center; padding-left: 5%; padding-right: 5%">
                                    <v-menu
                                            ref="toDateMenu"
                                            v-model="toDateMenu"
                                            :close-on-content-click="false"
                                            :return-value.sync="pickedToDate"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="pickedToDate"
                                                    label="Date To"
                                                    outlined
                                                    rounded
                                                    prepend-icon="fas fa-calendar"
                                                    readonly
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="pickedToDate" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="toDateMenu = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.toDateMenu.save(pickedToDate)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div style="width: 100%; float: left; height: 50%; display: flex; justify-content: center; align-items: center; padding-left: 5%; padding-right: 5%">
                                    <v-text-field
                                            label="Time To"
                                            outlined
                                            rounded
                                            prepend-icon="fas fa-clock"
                                            type="time"
                                            v-model="pickedToTime"
                                    ></v-text-field>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <div style="width: 50%; height: 100%; float: left">

                    <div style="height: 10%; width: 100%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 2vw; color: rgba(0,0,0,0.5)">
                        Preview
                    </div>

                    <div style="width: 100%; height: 90%; padding: 4%">

                        <v-card  style="width: 100%; height: 100%">
                            <v-toolbar @mouseleave="collapseBanner(false)" @mouseenter="collapseBanner(true)" :width="toolbarWidth" :color="alertColor" absolute :collapse="alertCollapse">
                                <v-icon v-if="alertCollapse"  style="color: white; font-size: 150%">{{alertIcon}}</v-icon>
                                <v-fade-transition>
                                    <div v-if="collapseText" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; font-weight: bold; color: white">
                                        <v-icon  style="color: white; padding-right: 1.5%">{{alertIcon}}</v-icon>  {{alertText}}
                                    </div>
                                </v-fade-transition>
                            </v-toolbar>
                            <div style="width: 100%; height: 10%; background: #2e2e2e"></div>
                            <div style="width: 100%; height: 5%; background: white"></div>
                            <div style="width: 100%; height: 7%; background: #cccccc"></div>
                            <div style="width: 100%; height: 70%; background: white"></div>
                            <div style="width: 100%; height: 5%; background: white; border-top-style: solid; border-width: 1px; border-color: lightgray"></div>
                        </v-card>
                    </div>
                </div>
            </div>
            <div style="width: 100%; height: 10%">
                <v-btn @click="activateAnnouncement" width="45%" height="75%" rounded color="#2e2e2e" style="color: white" >Start</v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { AXIOS } from '../../http-common'
import VueApexCharts from 'vue-apexcharts'

Vue.use(Vuetify)
Vue.use(VueApexCharts)
export default {

  components: {
    apexcharts: VueApexCharts
  },

  props: ['announcementState'],

  data () {
    return {

      currentTime: new Date(),
      annannoucementStartTime: '',
      annannoucementEndTime: '',

      sendStartTime: '',

      pickedFromDate: '',
      pickedToDate: '',
      pickedFromTime: '',
      pickedToTime: '',

      fromDateMenu: false,
      toDateMenu: false,

      annoucementStateProcess: this.announcementState,

      colorValue: '',
      annoucementActive: '',
      annoucementText: '',
      annoucementColour: '',
      annoucementIcon: '',
      annoucementId: '',

      selectedIcon1: '',
      selectedIcon2: '',
      selectedIcon3: '',
      selectedIcon4: '',
      selectedIcon5: '',
      selectedIcon6: '',
      selectedIcon7: '',
      selectedIcon8: '',

      alertText: 'Alert Demo Text',
      alertIcon: 'fas fa-circle-notch',
      alertColor: 'purple',

      alertCollapse: true,
      collapseText: false,
      toolbarWidth: '70px'
    }
  },
  watch: {
    pickedFromTime: function () {
      this.sendStartTime = this.pickedFromDate + 'T' + this.pickedFromTime + ':00.000'
    },
    pickedFromDate: function () {
      this.sendStartTime = this.pickedFromDate + 'T' + this.pickedFromTime + ':00.000'
    },
    pickedToDate: function () {
      this.sendStartTime = this.pickedFromDate + 'T' + this.pickedFromTime + ':00.000'
    },
    pickedToTime: function () {
      this.sendEndTime = this.pickedToDate + 'T' + this.pickedToTime + ':00.000'
    },
    alertCollapse: function (x) {
      if (x == true) { this.toolbarWidth = '70px' } else { this.toolbarWidth = '100%' }
    }
  },
  created: function () {
    document.title = 'Chattube - Announcements'
    this.getAnnouncement()
  },
  computed: {

  },
  methods: {

    getAnnouncement () {
      AXIOS({
        method: 'GET',
        url: 'api/announcement/',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session')
        }
      })
        .then(response => {
          this.annoucementId = response.data[0].id
          this.annoucementActive = response.data[0].active
          this.annoucementText = response.data[0].information
          this.annoucementIcon = response.data[0].icon
          this.annoucementColour = response.data[0].colour
          this.annannoucementStartTime = response.data[0].startTime
          this.annannoucementEndTime = response.data[0].endTime

          this.alertText = response.data[0].information
          this.alertColor = response.data[0].colour
          this.colorValue = response.data[0].colour
          this.alertIcon = response.data[0].icon
          this.sendStartTime = response.data[0].startTime
          this.sendEndTime = response.data[0].endTime

          this.pickedFromTime = response.data[0].startTime.substr(11, 5)
          this.pickedToTime = response.data[0].endTime.substr(11, 5)
          this.pickedFromDate = response.data[0].startTime.substr(0, 10)
          this.pickedToDate = response.data[0].endTime.substr(0, 10)
          this.selectIcon(this.alertIcon)
        })
    },

    activateAnnouncement () {
      AXIOS({
        method: 'POST',
        url: 'api/admin/announcement/save',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session')
        },
        data: {
          id: this.annoucementId,
          active: true,
          colour: this.alertColor,
          icon: this.alertIcon,
          information: this.alertText,
          startTime: this.sendStartTime,
          endTime: this.sendEndTime
        }
      })
        .then(response => {
          this.getAnnouncement()
          this.$emit('updateAnnouncementTrigger', this.annoucementStateProcess = true)
        },
        (err) => {
          if (err.response.status == 403 || err.response.status == 401) {

          }
        }
        )
    },

    selectIcon (i) {
      if (i == 1 || i == 'fas fa-exclamation-triangle') {
        this.alertIcon = 'fas fa-exclamation-triangle'
        this.selectedIcon1 = 'black'
        this.selectedIcon2 = ''
        this.selectedIcon3 = ''
        this.selectedIcon4 = ''
        this.selectedIcon5 = ''
        this.selectedIcon6 = ''
        this.selectedIcon7 = ''
        this.selectedIcon8 = ''
      } else if (i == 2 || i == 'fas fa-exclamation-circle') {
        this.alertIcon = 'fas fa-exclamation-circle'
        this.selectedIcon1 = ''
        this.selectedIcon2 = 'black'
        this.selectedIcon3 = ''
        this.selectedIcon4 = ''
        this.selectedIcon5 = ''
        this.selectedIcon6 = ''
        this.selectedIcon7 = ''
        this.selectedIcon8 = ''
      } else if (i == 3 || i == 'fas fa-info-circle') {
        this.alertIcon = 'fas fa-info-circle'
        this.selectedIcon1 = ''
        this.selectedIcon2 = ''
        this.selectedIcon3 = 'black'
        this.selectedIcon4 = ''
        this.selectedIcon5 = ''
        this.selectedIcon6 = ''
        this.selectedIcon7 = ''
        this.selectedIcon8 = ''
      } else if (i == 4 || i == 'fas fa-question-circle') {
        this.alertIcon = 'fas fa-question-circle'
        this.selectedIcon1 = ''
        this.selectedIcon2 = ''
        this.selectedIcon3 = ''
        this.selectedIcon4 = 'black'
        this.selectedIcon5 = ''
        this.selectedIcon6 = ''
        this.selectedIcon7 = ''
        this.selectedIcon8 = ''
      } else if (i == 5 || i == 'fas fa-minus-circle') {
        this.alertIcon = 'fas fa-minus-circle'
        this.selectedIcon1 = ''
        this.selectedIcon2 = ''
        this.selectedIcon3 = ''
        this.selectedIcon4 = ''
        this.selectedIcon5 = 'black'
        this.selectedIcon6 = ''
        this.selectedIcon7 = ''
        this.selectedIcon8 = ''
      } else if (i == 6 || i == 'fas fa-tools') {
        this.alertIcon = 'fas fa-tools'
        this.selectedIcon1 = ''
        this.selectedIcon2 = ''
        this.selectedIcon3 = ''
        this.selectedIcon4 = ''
        this.selectedIcon5 = ''
        this.selectedIcon6 = 'black'
        this.selectedIcon7 = ''
        this.selectedIcon8 = ''
      } else if (i == 7 || i == 'fas fa-times-circle') {
        this.alertIcon = 'fas fa-times-circle'
        this.selectedIcon1 = ''
        this.selectedIcon2 = ''
        this.selectedIcon3 = ''
        this.selectedIcon4 = ''
        this.selectedIcon5 = ''
        this.selectedIcon6 = ''
        this.selectedIcon7 = 'black'
        this.selectedIcon8 = ''
      } else if (i == 8 || i == 'fas fa-check-circle') {
        this.alertIcon = 'fas fa-check-circle'
        this.selectedIcon1 = ''
        this.selectedIcon2 = ''
        this.selectedIcon3 = ''
        this.selectedIcon4 = ''
        this.selectedIcon5 = ''
        this.selectedIcon6 = ''
        this.selectedIcon7 = ''
        this.selectedIcon8 = 'black'
      }
    },

    collapseBanner (state) {
      if (state == true) {
        setTimeout(() => this.alertCollapse = false, 1000)
        setTimeout(() => this.collapseText = true, 1150)
      } else {
        setTimeout(() => this.alertCollapse = true, 2000)
        setTimeout(() => this.collapseText = false, 1750)
      }
    }

  }
}
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
        padding: 1%;
    }

</style>
